window.__pdpColorSwatchA11yBound = window.__pdpColorSwatchA11yBound || false;

/* Custom */
$(function(){
   var lastScrollTop = 0, delta = 5;
   $(window).scroll(function(){
       var nowScrollTop = $(this).scrollTop();
       if(Math.abs(lastScrollTop - nowScrollTop) >= delta){
          if (nowScrollTop > lastScrollTop){
              // ACTION ON
              // SCROLLING DOWN 
              $('body').removeClass("page_scroll_up_new")
          } else {
              // ACTION ON
              // SCROLLING UP 
              $('body').addClass("page_scroll_up_new")
          }
       lastScrollTop = nowScrollTop;
       }
   });
});

$(function(){
	var stickyHeaderTop = 150;
	$(window).scroll(function(){
		if( $(window).scrollTop() > stickyHeaderTop ) {
			if($('body').hasClass("fix-header") == false)
			{
				$('body').addClass('fix-header');
			}
		} else {
			$('body').removeClass('fix-header');
		}
	});
});

$(".site-nav--has-dropdown").hover(function(){
   var width = $(document).width();
   if(width > 991)
   {
     $(this).addClass("site-nav--active-dropdown");
     //$('body').addClass("is-white-header");
     $('body').addClass("open_megamenu");
   }
 }, function(){
   var width = $(document).width();
   if(width > 991)
   {
     $(this).removeClass("site-nav--active-dropdown");
     //$('body').removeClass("is-white-header");
     $('body').removeClass("open_megamenu");
   }
 })


$(".js-drawer-open-nav").click(function() {
  $('body, html').toggleClass("menu_open");
  $(".Mega_menu_mobile_inner_new").removeClass("open_inner_menu");
  
  if($('body').hasClass("fix-header") == true) {
    var header = $(".Header_main_inner_new").outerHeight(true);
    var total = header;
    $("#NavDrawer").css("top",total+"px");  
    $("#NavDrawer").height("calc(100% - "+total+"px)");
    $(".Mega_menu_mobile_inner_new").height("calc(100vh - "+total+"px)");
  } else {
    var header = $(".Header_main_inner_new").outerHeight(true);
    var announcement = $(".Index_announcement_bar_main_new").outerHeight(true);
    var total = header + announcement;
    $("#NavDrawer").css("top",total+"px");  
    $("#NavDrawer").height("calc(100% - "+total+"px)");  
    $(".Mega_menu_mobile_inner_new").height("calc(100vh - "+total+"px)");
  }
})

$(".cart-item").click(function() {
  $('body, html').removeClass("menu_open");
  $(".Mega_menu_mobile_inner_new").removeClass("open_inner_menu");
})

$(".tab_new .tablinks").click(function(){
  var title = $(this).html();
  $(".Index_tabs_collections_allheading_title_new .collection_name_new").html(title);
  $(".collection_details_slider_new .content span").html(title);
  var width = $(document).width();
  if(width < 769 && $(this).closest('.Tabs_collections_v2').length == 0)
  {
    $(".tab_new").slideUp();
  }
})
$(".Index_tabs_collections_allheading_title_new h2 span.collection_name_main_new").click(function(){
  $(this).toggleClass("active");
  $(".tab_new").slideToggle();
})

$(".collection_details_slider_new").click(function(){
  $(this).addClass("open");
})

$(".Mega_menu_mobile_main_new .site-nav__link").click(function(){
  $(this).next(".Mega_menu_mobile_inner_new").addClass("open_inner_menu");
})

$(".Mega_menu_mobile_leftside_titleboxs_new").click(function(){
  $(".Mega_menu_mobile_inner_new").removeClass("open_inner_menu");
})

$(".search-bar").keyup(function(){
  $(".search-group .close_icon_new").addClass("display_close_icon");
});

$(".Mega_menu_mobile_main_new .site-nav__link--button").click(function(){
  $(this).next(".site-nav__dropdown").addClass("open_inner_menu");
})

$(".Mega_menu_mobile_leftside_title_back_new").click(function(){
  $(this).parent().parent().parent(".site-nav__dropdown").removeClass("open_inner_menu");
})

$(".js-drawer-open-nav").click(function() {
  $(".site-nav__dropdown").removeClass("open_inner_menu");
})


function accordionScript(){
  $(".accordion .question").click(function(){
    if($(this).parent("li").hasClass("open") == false)
    {
      $(this).parent().parent().find(".answer").slideUp();
      $(this).parent().parent().find("li").removeClass("open");
      
      $(this).next(".answer").slideDown();
      $(this).parent(".accordion li").addClass("open");
    } 
    else
    {
      $(this).parent().parent().find(".answer").slideUp();
      $(this).parent().parent().find("li").removeClass("open");
    }
  })
}

accordionScript();


function initProductAccordions(scope) {
  var container = scope || document;
  container.querySelectorAll(".product-accordion-group").forEach(function(group) {
    group.querySelectorAll(".product-accordion__trigger").forEach(function(trigger) {
      trigger.addEventListener("click", function() {
        var accordion = trigger.closest(".product-accordion");
        var isOpen = accordion.classList.contains("is-open");

        group.querySelectorAll(".product-accordion.is-open").forEach(function(other) {
          if (other !== accordion) {
            other.classList.remove("is-open");
            var otherTrigger = other.querySelector(".product-accordion__trigger");
            if (otherTrigger) otherTrigger.setAttribute("aria-expanded", "false");
            var otherContent = other.querySelector(".product-accordion__content");
            if (otherContent) otherContent.setAttribute("aria-hidden", "true");
          }
        });

        accordion.classList.toggle("is-open", !isOpen);
        trigger.setAttribute("aria-expanded", String(!isOpen));
        var content = accordion.querySelector(".product-accordion__content");
        if (content) content.setAttribute("aria-hidden", String(isOpen));
      });
    });
  });
}

window.initProductAccordions = initProductAccordions;
initProductAccordions();

function sectionwidth()
{
  var width = $(document).width();
  var Product_main_template_leftrightboth_new = $(".Product_main_template_leftrightboth_new").width();
  var totalwidth = width - Product_main_template_leftrightboth_new;
  totalwidth = totalwidth/2;
  var Product_meta_variant_product_list_main_new = $(".Product_meta_variant_product_list_main_new").width();
  var finalwidth = totalwidth + Product_meta_variant_product_list_main_new;
  $(".product_upsells_items_new").css("width",finalwidth+"px");

}
sectionwidth()
$(window).resize(function(){
  sectionwidth()
});

$(".search-group .close_icon_new").click(function() {
  var width = $(document).width();
  if(width < 769)
  {
    $(this).removeClass("display_close_icon");
    $(".search-bar").val('');
    $(".results-box").css("display","none");
  }
  $("#pageheader").hide();
  $("#pageheader").removeClass('is-active');
})

function weatherSectionScript() {
  $(".Product_meta_object_all_weather_innerleft_innerbox_innerinfo_1_new").click(function() {
    var width = $(document).width();
    if(width >= 769)
    {
      $(this).next(".Product_meta_object_all_weather_innerleft_innerbox_innerinfo_2_new").css("display","block");
    }
  })
  $(".Product_meta_object_all_weather_innerleft_innerbox_innerinfo_2_detail_close_new, .Product_meta_object_all_weather_innerleft_innerbox_innerinfo_2_detail_3_btns_new .btn").click(function() {
    var width = $(document).width();
    if(width >= 769)
    {
     $(".Product_meta_object_all_weather_innerleft_innerbox_innerinfo_2_new").css("display","none");
    }
  })
  
  $(".Product_meta_object_all_weather_innerleft_innerbox_innerinfo_1_new").click(function(){
    var width = $(document).width();
    if(width < 769)
    {
      if($(this).hasClass("open") == false)
      {
        $(this).parent().parent().parent().find(".Product_meta_object_all_weather_innerleft_innerbox_innerinfo_2_new").slideUp();
        $(this).parent().parent().parent().find(".Product_meta_object_all_weather_innerleft_innerbox_innerinfo_1_new").removeClass("open");
        
        $(this).next(".Product_meta_object_all_weather_innerleft_innerbox_innerinfo_2_new").slideDown();
        $(this).addClass("open");
      } 
      else
      {
        $(this).parent().parent().parent().find(".Product_meta_object_all_weather_innerleft_innerbox_innerinfo_2_new").slideUp();
        $(this).parent().parent().parent().find(".Product_meta_object_all_weather_innerleft_innerbox_innerinfo_1_new").removeClass("open");
      }
    }
  })
}

weatherSectionScript();

function mainImageProductAccordion(){
  $(".Product_image_sizing_list_name_new").click(function() {
    $(this).toggleClass("open");
    $(this).next(".Product_image_sizing_list_main_new").slideToggle();
  })
}

mainImageProductAccordion();


$(window).load(function() {
  var handle = $(".Product_image_sizing_list_new.selected").attr('product_handle');
  $('.product-variant-select__input [value='+handle+']').trigger("click");
})

// product options accessibility




/*$('.Product_meta_short_description_explore_new a').click(function(e) {
  e.preventDefault();
  $('html, body').animate({
    scrollTop: $('.Product_meta_object_all_weather_main_new').offset().top
  }, 500);
});*/

function scrollLink(){
  $('.Product_reviews_inner_new').click(function(e) {
    e.preventDefault();
    $('html, body').animate({
      scrollTop: $('.Product_review_main_new').offset().top
    }, 700);
  });
  
  // $('a[href^="#"]').click(function() {
  //   $('html, body').animate({
  //       scrollTop: $('#' + $.attr(this, 'href').substr(1)).offset().top
  //     }, 700);
  //   return false;
  // });
}

scrollLink()

$('.quick_shop_main_new').click(function(e) {
    $(e.currentTarget).addClass('btn--loading');
    let desc = $(this); 
    let id = $(this).parent().parent().find('.color_swatches .color-swatch.active').attr('data-id');
    console.log("id"+id);
    let data = {
        items: [
            {
                quantity: 1,
                id: id,
            },
        ],
    };
    jQuery.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data,
        dataType: 'json',
        success: function (item) {
            $('.drawer').addClass('is-active is-visible');
            init();
            loadCart();
            formOverride();
            $(e.currentTarget).removeClass('btn--loading');
        },
        error: function (error) {
          desc.find(".quick_shop_error_new").fadeIn();
          desc.find(".quick_shop_error_new").html(error.responseJSON.description);
          $(e.currentTarget).removeClass('btn--loading');
          setTimeout(function() {
            $(".quick_shop_error_new").fadeOut();
          },2000)
        }
    });
})

let Index_announcement_slider = new Swiper('.Index_announcement_slider', {
  spaceBetween: 0,
  slidesPerView: 1,
  draggable: true,
  effect: "fade",
  loop: true,
  watchSlidesProgress: true,
  autoHeight:!1,
  watchOverflow:!0,
  threshold:10,
  autoplay: {
    delay: 3000,
    disableOnInteraction: false,
  },
  mousewheel: {
    forceToAxis: true,
  }
});


let Index_top_slider = new Swiper('.Index_top_slider', {
  loop: true,
  grabCursor: false,
  spaceBetween: 0,
  slidesPerGroup: 1,
  slidesPerView: 1,
  watchSlidesProgress: true,
  draggable:!0,
  autoHeight:!1,
  watchOverflow:!0,
  threshold:10,
  effect: "fade",
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  mousewheel:{
    forceToAxis:!0
  },
  autoplay: {
    delay: 5000,
    disableOnInteraction: false,
  }
});

let Index_testimonials_slider = new Swiper('.Index_testimonials_slider', {
  loop: false,
  grabCursor: false,
  spaceBetween: 40,
  slidesPerGroup: 1,
  slidesPerView: 2,
  watchSlidesProgress: true,
  draggable:!0,
  autoHeight:!1,
  watchOverflow:!0,
  threshold:10,
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  scrollbar: {
    el: ".swiper-scrollbar"
  },
  effect: "fade",
  mousewheel:{
    forceToAxis:!0
  },
  autoplay: {
    delay: 3000,
    disableOnInteraction: false,
  },
  breakpoints: {
    0: {
      slidesPerView: 1,
    },
    769: {
      slidesPerView: 2,
      spaceBetween: 20,
    },
    992: {
      slidesPerView: 2,
      spaceBetween: 20,
    },
    1200: {
      slidesPerView: 2,
      spaceBetween: 20,
    },
    1360: {
      slidesPerView: 2,
      spaceBetween: 30,
    },
    1441: {
      slidesPerView: 2,
      freeMode:!0
    }
  }
});

var pagewidth = $(document).width();
if(pagewidth > 768)
{
  let Index_guides_slider = new Swiper('.Index_guides_slider', {
    loop: false,
    grabCursor: false,
    spaceBetween: 10,
    slidesPerView: 2,
    watchSlidesProgress: true,
    draggable:!0,
    autoHeight:!1,
    watchOverflow:!0,
    threshold:10,
    scrollbar: {
      el: ".swiper-scrollbar"
    },
    mousewheel:{
      forceToAxis:!0
    },
    breakpoints: {
      0: {
        slidesPerView: "auto",
      },
      769: {
        slidesPerView: "auto",
      },
      992: {
        slidesPerView: "auto",
      },
      1200: {
        slidesPerView: "auto",
      },
      1360: {
        slidesPerView: "auto",
      },
      1441: {
        slidesPerView: 2,
        freeMode:!0
      }
    }
  });
}

let Index_instagram_slider = new Swiper('.Index_instagram_slider', {
  loop: true,
  grabCursor: false,
  spaceBetween: 10,
  slidesPerView: 5,
  watchSlidesProgress: true,
  scrollbar: {
    el: ".swiper-scrollbar"
  },
   autoplay:{
    delay: 5000,
  },
  draggable:!0,
  autoHeight:!1,
  watchOverflow:!0,
  threshold:10,
  mousewheel:{
    forceToAxis:!0
  },
  centeredSlides: true,
  breakpoints: {
    0: {
      slidesPerView: "auto",
      centeredSlides: true
    },
    769: {
      slidesPerView: "auto"
    },
    992: {
      slidesPerView: "auto"
    },
    1200: {
      slidesPerView: "auto"
    },
    1360: {
      slidesPerView: "auto"
    },
    1441: {
      slidesPerView: 5,
      centeredSlides: false,
      freeMode:1
    }
  }
});

let Comparison_instagram_slider = new Swiper('.Comparison_instagram_slider', {
  loop: true,
  grabCursor: false,
  spaceBetween: 10,
  slidesPerView: 5,
  watchSlidesProgress: true,
  scrollbar: {
    el: ".swiper-scrollbar"
  },
  draggable:!0,
  autoHeight:!1,
  watchOverflow:!0,
  threshold:10,
  mousewheel:{
    forceToAxis:!0
  },
  centeredSlides: true,
  breakpoints: {
    0: {
      slidesPerView: "auto",
      centeredSlides: true
    },
    769: {
      slidesPerView: "auto"
    },
    992: {
      slidesPerView: "auto"
    },
    1200: {
      slidesPerView: "auto"
    },
    1360: {
      slidesPerView: "auto"
    },
    1441: {
      slidesPerView: 5,
      centeredSlides: false,
      freeMode:1
    }
  }
});

new Swiper('.hp_feature_collection_slider', {
  // Important: loop + freeMode + fractional views can cause jumps
  loop: false,

  slidesPerView: 1.2,
  spaceBetween: 12,
  slidesPerGroup: 1,
  speed: 450,
  grabCursor: true,
  watchOverflow: true,

  // Keep progress off unless you need it
  watchSlidesProgress: false,

  scrollbar: { el: '.swiper-scrollbar', draggable: true },

  // Make wheel scroll horizontal, snap 1 slide, let page scroll at ends
  mousewheel: {
    eventsTarget: '.hp_feature_collection_slider',
    forceToAxis: true,
    releaseOnEdges: true,
    thresholdDelta: 30,   // smaller = more responsive
    thresholdTime: 200,
    sensitivity: 0.6
  },

  // No freeMode = true snapping per slide (no weird inertia)
  freeMode: false,

  breakpoints: {
    768: { slidesPerView: 1.6 },
    992: { slidesPerView: 3.5 }
  }
});

new Swiper('.hp_best_sellers_slider', {
  // Important: loop + freeMode + fractional views can cause jumps
  loop: false,

  slidesPerView: 1.2,
  spaceBetween: 12,
  slidesPerGroup: 1,
  speed: 450,
  grabCursor: true,
  watchOverflow: true,

  // Keep progress off unless you need it
  watchSlidesProgress: false,

  scrollbar: { el: '.swiper-scrollbar', draggable: true },

  // Make wheel scroll horizontal, snap 1 slide, let page scroll at ends
  mousewheel: {
    eventsTarget: '.hp_best_sellers_slider',
    forceToAxis: true,
    releaseOnEdges: true,
    thresholdDelta: 30,   // smaller = more responsive
    thresholdTime: 200,
    sensitivity: 0.6
  },

  // No freeMode = true snapping per slide (no weird inertia)
  freeMode: false,

  breakpoints: {
    768: { slidesPerView: 1.6 },
    992: { slidesPerView: 5.3 }
  }
});

new Swiper('.Index_featured_collection_slider', {
  loop: false,
  grabCursor: false,
  spaceBetween: 10,
  slidesPerView: 1.75,
  watchSlidesProgress: true,
  scrollbar: {
    el: ".swiper-scrollbar",
    draggable: true,
  },
  draggable:!0,
  autoHeight:!1,
  watchOverflow:!0,
  threshold:10,
  mousewheel:{
    forceToAxis:!0
  },
  breakpoints: {
    992: {
      slidesPerView: 3,
      freeMode:!0
    }
  }
});

new Swiper('.Custom_collection_slider', {
  loop: false,
  grabCursor: false,
  spaceBetween: 10,
  slidesPerView: 1.5,
  watchSlidesProgress: true,
  scrollbar: {
    el: ".swiper-scrollbar"
  },
  draggable:!0,
  autoHeight:!1,
  watchOverflow:!0,
  threshold:10,
  mousewheel:{
    forceToAxis:!0
  },
  breakpoints: {
    992: {
      slidesPerView: 2.5,
      freeMode:!0
    }
  }
});

new Swiper('.hp_collage_slider', {
  // Important: loop + freeMode + fractional views can cause jumps
  loop: false,

  slidesPerView: 1.2,
  spaceBetween: 12,
  slidesPerGroup: 1,
  speed: 450,
  grabCursor: true,
  watchOverflow: true,

  // Keep progress off unless you need it
  watchSlidesProgress: false,

  scrollbar: { el: '.swiper-scrollbar', draggable: true },

  // Make wheel scroll horizontal, snap 1 slide, let page scroll at ends
  mousewheel: {
    eventsTarget: '.hp_collage_slider',
    forceToAxis: true,
    releaseOnEdges: true,
    thresholdDelta: 30,   // smaller = more responsive
    thresholdTime: 200,
    sensitivity: 0.6
  },

  // No freeMode = true snapping per slide (no weird inertia)
  freeMode: false,

  breakpoints: {
    768: { slidesPerView: 1.6 },
    992: { slidesPerView: 2.4 }
  }
});


/**
 * Product expander Swiper
 */

// let init = false;
// let productExpanderSwiper;

// function productExpander() {
//   if (window.innerWidth <= 991) {
//     if (!init) {
//       init = true;
//       productExpanderSwiper = new Swiper('.js-product-expander', {
//         loop: false,
//         grabCursor: false,
//         spaceBetween: 16,
//         slidesPerView: 1.5,
//         watchSlidesProgress: true,
//         scrollbar: {
//           el: '.swiper-scrollbar',
//         },
//         draggable: !0,
//         autoHeight: !1,
//         watchOverflow: !0,
//         threshold: 10,
//         mousewheel: {
//           forceToAxis: !0,
//         }
//       });
//     }
//   } else if (init) {
//     productExpanderSwiper.destroy();
//     init = false;
//   }
// }

// productExpander();

// window.addEventListener('resize', productExpander);

new Swiper('.Index_featured_collection_slider_4', {
  loop: false,
  grabCursor: false,
  spaceBetween: 10,
  slidesPerView: 1.75,
  watchSlidesProgress: true,
  scrollbar: {
    el: ".swiper-scrollbar"
  },
  draggable:!0,
  autoHeight:!1,
  watchOverflow:!0,
  threshold:10,
  mousewheel:{
    forceToAxis:!0
  },
  breakpoints: {
    992: {
      slidesPerView: 3.5,
    }
  }
});

new Swiper('.hp_feature_collection_slider_4', {
  loop: false,
  grabCursor: false,
  spaceBetween: 10,
  slidesPerView: 1.75,
  watchSlidesProgress: true,
  scrollbar: {
    el: ".swiper-scrollbar"
  },
  draggable:!0,
  autoHeight:!1,
  watchOverflow:!0,
  threshold:10,
  mousewheel:{
    forceToAxis:!0
  },
  breakpoints: {
    992: {
      slidesPerView: 3.5,
    }
  }
});

new Swiper('.hp_best_sellers_slider_4', {
  loop: false,
  grabCursor: false,
  spaceBetween: 10,
  slidesPerView: 1.75,
  watchSlidesProgress: true,
  scrollbar: {
    el: ".swiper-scrollbar"
  },
  draggable:!0,
  autoHeight:!1,
  watchOverflow:!0,
  threshold:10,
  mousewheel:{
    forceToAxis:!0
  },
  breakpoints: {
    0:   { enabled: false },  
    992: {
      slidesPerView: 3.5,
    }
  }
});

new Swiper('.Index_featured_collection_slider_small_grid', {
  loop: false,
  grabCursor: false,
  spaceBetween: 10,
  slidesPerView: 1.75,
  watchSlidesProgress: true,
  scrollbar: {
    el: ".swiper-scrollbar"
  },
  draggable:!0,
  autoHeight:!1,
  watchOverflow:!0,
  threshold:10,
  mousewheel:{
    forceToAxis:!0
  },
  breakpoints: {
    992: {
      slidesPerView: 2.75,
      freeMode:!0
    }
  }
});

new Swiper('.article_collection_slider', {
  loop: false,
  grabCursor: false,
  spaceBetween: 10,
  slidesPerView: 3,
  watchSlidesProgress: true,
  draggable:!0,
  autoHeight:!1,
  watchOverflow:!0,
  threshold:10,
  mousewheel:{
    forceToAxis:!0
  },
  breakpoints: {
    0: {
      slidesPerView: "auto",
    },
    769: {
      slidesPerView: "auto",
    },
    992: {
      slidesPerView: "auto",
    },
    1200: {
      slidesPerView: "auto",
    },
    1360: {
      slidesPerView: "auto",
    },
    1441: {
      slidesPerView: "auto",
      freeMode:!0
    }
  }
});

new Swiper('.Index_video_image_columns_slider', {
  loop: false,
  grabCursor: false,
  spaceBetween: 10,
  slidesPerView: 3,
  watchSlidesProgress: true,
  draggable:!0,
  autoHeight:!1,
  watchOverflow:!0,
  threshold:10,
  mousewheel:{
    forceToAxis:!0
  },
  breakpoints: {
    0: {
      slidesPerView: "auto",
      loop: true,
    },
    769: {
      slidesPerView: 3,
    },
    992: {
      slidesPerView: 3,
    },
    1200: {
      slidesPerView: 3,
    },
    1360: {
      slidesPerView: 3,
    },
    1441: {
      slidesPerView: 3,
      freeMode:!0
    }
  }
});

function upsellMainSlider(){
  new Swiper('.Product_upsells_slider', {
    loop: false,
    grabCursor: false,
    spaceBetween: 10,
    slidesPerView: "auto",
    watchSlidesProgress: true,
    scrollbar: {
      el: ".swiper-scrollbar"
    },
    freeMode:!0,
    draggable:!0,
    autoHeight:!1,
    watchOverflow:!0,
    threshold:10,
    mousewheel:{
      forceToAxis:!0
    }
  });
}

upsellMainSlider();

function productListSectionSlider() {
  new Swiper('.Product_list_slider', {
    loop: false,
    grabCursor: false,
    spaceBetween: 10,
    slidesPerView: 3.5,
    watchSlidesProgress: true,
    scrollbar: {
      el: ".swiper-scrollbar"
    },
    draggable:!0,
    autoHeight:!1,
    watchOverflow:!0,
    threshold:10,
    mousewheel:{
      forceToAxis:!0
    },
    breakpoints: {
      0: {
        slidesPerView: 1.75,
      },
      769: {
        slidesPerView: 3.5,
      },
      1441: {
        slidesPerView: 3.5,
        freeMode:!0
      }
    }
  });
}
productListSectionSlider();

function mainProductMobileSlider(){
  let product_image_slider_new = new Swiper('.product_image_slider_new', {
    loop: false,
    grabCursor: false,
    spaceBetween: 0,
    slidesPerView: "auto",
    watchSlidesProgress: true,
    scrollbar: {
      el: ".swiper-scrollbar"
    },
    draggable:!0,
    autoHeight:!1,
    watchOverflow:!0,
    threshold:10,
    mousewheel:{
      forceToAxis:!0
    },
    breakpoints: {
      0: {
        slidesPerView: 1.1,
      },
      769: {
        slidesPerView: "auto",
      },
      992: {
        slidesPerView: "auto",
      },
      1200: {
        slidesPerView: "auto",
      },
      1360: {
        slidesPerView: "auto",
      },
      1441: {
        slidesPerView: 4,
        freeMode:!0
      }
    }
  })
}

mainProductMobileSlider();

function collectionListSlider(){

  let selectedSliderIndex = $('.collection_list_slider_new .selected').index();

  if(selectedSliderIndex === -1){
    selectedSliderIndex = 0;
  }
  
  window.collection_list_slider_new = new Swiper('.collection_list_slider_new', {
    loop: false,
    grabCursor: false,
    spaceBetween: 10,
    slidesPerView: "auto",
    watchSlidesProgress: true,
    scrollbar: {
      el: ".swiper-scrollbar"
    },
    draggable:!0,
    autoHeight:!1,
    watchOverflow:!0,
    threshold:10,
    mousewheel:{
      forceToAxis:!0
    },
    breakpoints: {
      0: {
        slidesPerView: "auto",
        initialSlide: selectedSliderIndex,
      },
      768: {
        slidesPerView: 4,
      },
      992: {
        slidesPerView: 4,
      },
      1200: {
        slidesPerView: 4,
      },
      1360: {
        slidesPerView: 4,
      },
      1441: {
        slidesPerView: 4,
        freeMode:!0
      }
    }
  });

}

collectionListSlider();

let swiperInstance;

function initSwiper() {
  const slideWidth = 155; // Desired slide width
  const spaceBetween = 20; // Desired space between slides
  const container = document.querySelector('.compare-chart__right_slider_new');
  if (!container) return;
  const containerWidth = container.offsetWidth; // Get container width dynamically

  const slidesPerView = (containerWidth + spaceBetween) / (slideWidth + spaceBetween);

  const screenWidth = window.innerWidth;

  // Enable Swiper only on mobile (example: widths < 768px)
  if (screenWidth < 769) {
    if (!swiperInstance) {
      swiperInstance = new Swiper('.compare-chart__right_slider_new', {
        loop: false,
        grabCursor: false,
        spaceBetween: 20,
        slidesPerView: slidesPerView,
        watchSlidesProgress: true,
        draggable: true,
        autoHeight: false,
        watchOverflow: true,
        threshold: 10,
        scrollbar: {
          el: ".swiper-scrollbar"
        },
        mousewheel: {
          forceToAxis: true,
        },
        breakpoints: {
          375: {
            slidesPerView: slidesPerView,
          },
          425: {
            slidesPerView: slidesPerView,
          },
          768: {
            slidesPerView: slidesPerView,
          }
        },
      });
    }
  } else {
    // Destroy Swiper instance if initialized
    if (swiperInstance) {
      swiperInstance.destroy(true, true);
      swiperInstance = null;
    }
  }
}

// Initialize on page load
initSwiper();

// Re-initialize on window resize
window.addEventListener('resize', initSwiper);


/* marquee  */
(function(factory){"use strict";if(typeof define==="function"&&define.amd){define(["jquery"],factory)}else if(typeof exports!=="undefined"){module.exports=factory(require("jquery"))}else{factory(jQuery)}})(function($){$.fn.marquee=function(options){return this.each(function(){var o=$.extend({},$.fn.marquee.defaults,options),$this=$(this),$marqueeWrapper,containerWidth,animationCss,verticalDir,elWidth,loopCount=3,playState="animation-play-state",css3AnimationIsSupported=false,_prefixedEvent=function(element,type,callback){var pfx=["webkit","moz","MS","o",""];for(var p=0;p<pfx.length;p++){if(!pfx[p])type=type.toLowerCase();element.addEventListener(pfx[p]+type,callback,false)}},_objToString=function(obj){var tabjson=[];for(var p in obj){if(obj.hasOwnProperty(p)){tabjson.push(p+":"+obj[p])}}tabjson.push();return"{"+tabjson.join(",")+"}"},_startAnimationWithDelay=function(){$this.timer=setTimeout(animate,o.delayBeforeStart)},methods={pause:function(){if(css3AnimationIsSupported&&o.allowCss3Support){$marqueeWrapper.css(playState,"paused")}else{if($.fn.pause){$marqueeWrapper.pause()}}$this.data("runningStatus","paused");$this.trigger("paused")},resume:function(){if(css3AnimationIsSupported&&o.allowCss3Support){$marqueeWrapper.css(playState,"running")}else{if($.fn.resume){$marqueeWrapper.resume()}}$this.data("runningStatus","resumed");$this.trigger("resumed")},toggle:function(){methods[$this.data("runningStatus")==="resumed"?"pause":"resume"]()},destroy:function(){clearTimeout($this.timer);$this.find("*").addBack().off();$this.html($this.find(".js-marquee:first").html())}};if(typeof options==="string"){if($.isFunction(methods[options])){if(!$marqueeWrapper){$marqueeWrapper=$this.find(".js-marquee-wrapper")}if($this.data("css3AnimationIsSupported")===true){css3AnimationIsSupported=true}methods[options]()}return}var dataAttributes={},attr;$.each(o,function(key){attr=$this.attr("data-"+key);if(typeof attr!=="undefined"){switch(attr){case"true":attr=true;break;case"false":attr=false;break}o[key]=attr}});if(o.speed){o.duration=parseInt($this.width(),10)/o.speed*1e3}verticalDir=o.direction==="up"||o.direction==="down";o.gap=o.duplicated?parseInt(o.gap):0;$this.wrapInner('<div class="js-marquee"></div>');var $el=$this.find(".js-marquee").css({"margin-right":o.gap,float:"left"});if(o.duplicated){$el.clone(true).appendTo($this)}$this.wrapInner('<div style="width:100000px" class="js-marquee-wrapper"></div>');$marqueeWrapper=$this.find(".js-marquee-wrapper");if(verticalDir){var containerHeight=$this.height();$marqueeWrapper.removeAttr("style");$this.height(containerHeight);$this.find(".js-marquee").css({float:"none","margin-bottom":o.gap,"margin-right":0});if(o.duplicated){$this.find(".js-marquee:last").css({"margin-bottom":0})}var elHeight=$this.find(".js-marquee:first").height()+o.gap;if(o.startVisible&&!o.duplicated){o._completeDuration=(parseInt(elHeight,10)+parseInt(containerHeight,10))/parseInt(containerHeight,10)*o.duration;o.duration=parseInt(elHeight,10)/parseInt(containerHeight,10)*o.duration}else{o.duration=(parseInt(elHeight,10)+parseInt(containerHeight,10))/parseInt(containerHeight,10)*o.duration}}else{elWidth=$this.find(".js-marquee:first").width()+o.gap;containerWidth=$this.width();if(o.startVisible&&!o.duplicated){o._completeDuration=(parseInt(elWidth,10)+parseInt(containerWidth,10))/parseInt(containerWidth,10)*o.duration;o.duration=parseInt(elWidth,10)/parseInt(containerWidth,10)*o.duration}else{o.duration=(parseInt(elWidth,10)+parseInt(containerWidth,10))/parseInt(containerWidth,10)*o.duration}}if(o.duplicated){o.duration=o.duration/2}if(o.allowCss3Support){var elm=document.body||document.createElement("div"),animationName="marqueeAnimation-"+Math.floor(Math.random()*1e7),domPrefixes="Webkit Moz O ms Khtml".split(" "),animationString="animation",animationCss3Str="",keyframeString="";if(elm.style.animation!==undefined){keyframeString="@keyframes "+animationName+" ";css3AnimationIsSupported=true}if(css3AnimationIsSupported===false){for(var i=0;i<domPrefixes.length;i++){if(elm.style[domPrefixes[i]+"AnimationName"]!==undefined){var prefix="-"+domPrefixes[i].toLowerCase()+"-";animationString=prefix+animationString;playState=prefix+playState;keyframeString="@"+prefix+"keyframes "+animationName+" ";css3AnimationIsSupported=true;break}}}if(css3AnimationIsSupported){animationCss3Str=animationName+" "+o.duration/1e3+"s "+o.delayBeforeStart/1e3+"s infinite "+o.css3easing;$this.data("css3AnimationIsSupported",true)}}var _rePositionVertically=function(){$marqueeWrapper.css("transform","translateY("+(o.direction==="up"?containerHeight+"px":"-"+elHeight+"px")+")")},_rePositionHorizontally=function(){$marqueeWrapper.css("transform","translateX("+(o.direction==="left"?containerWidth+"px":"-"+elWidth+"px")+")")};if(o.duplicated){if(verticalDir){if(o.startVisible){$marqueeWrapper.css("transform","translateY(0)")}else{$marqueeWrapper.css("transform","translateY("+(o.direction==="up"?containerHeight+"px":"-"+(elHeight*2-o.gap)+"px")+")")}}else{if(o.startVisible){$marqueeWrapper.css("transform","translateX(0)")}else{$marqueeWrapper.css("transform","translateX("+(o.direction==="left"?containerWidth+"px":"-"+(elWidth*2-o.gap)+"px")+")")}}if(!o.startVisible){loopCount=1}}else if(o.startVisible){loopCount=2}else{if(verticalDir){_rePositionVertically()}else{_rePositionHorizontally()}}var animate=function(){if(o.duplicated){if(loopCount===1){o._originalDuration=o.duration;if(verticalDir){o.duration=o.direction==="up"?o.duration+containerHeight/(elHeight/o.duration):o.duration*2}else{o.duration=o.direction==="left"?o.duration+containerWidth/(elWidth/o.duration):o.duration*2}if(animationCss3Str){animationCss3Str=animationName+" "+o.duration/1e3+"s "+o.delayBeforeStart/1e3+"s "+o.css3easing}loopCount++}else if(loopCount===2){o.duration=o._originalDuration;if(animationCss3Str){animationName=animationName+"0";keyframeString=$.trim(keyframeString)+"0 ";animationCss3Str=animationName+" "+o.duration/1e3+"s 0s infinite "+o.css3easing}loopCount++}}if(verticalDir){if(o.duplicated){if(loopCount>2){$marqueeWrapper.css("transform","translateY("+(o.direction==="up"?0:"-"+elHeight+"px")+")")}animationCss={transform:"translateY("+(o.direction==="up"?"-"+elHeight+"px":0)+")"}}else if(o.startVisible){if(loopCount===2){if(animationCss3Str){animationCss3Str=animationName+" "+o.duration/1e3+"s "+o.delayBeforeStart/1e3+"s "+o.css3easing}animationCss={transform:"translateY("+(o.direction==="up"?"-"+elHeight+"px":containerHeight+"px")+")"};loopCount++}else if(loopCount===3){o.duration=o._completeDuration;if(animationCss3Str){animationName=animationName+"0";keyframeString=$.trim(keyframeString)+"0 ";animationCss3Str=animationName+" "+o.duration/1e3+"s 0s infinite "+o.css3easing}_rePositionVertically()}}else{_rePositionVertically();animationCss={transform:"translateY("+(o.direction==="up"?"-"+$marqueeWrapper.height()+"px":containerHeight+"px")+")"}}}else{if(o.duplicated){if(loopCount>2){$marqueeWrapper.css("transform","translateX("+(o.direction==="left"?0:"-"+elWidth+"px")+")")}animationCss={transform:"translateX("+(o.direction==="left"?"-"+elWidth+"px":0)+")"}}else if(o.startVisible){if(loopCount===2){if(animationCss3Str){animationCss3Str=animationName+" "+o.duration/1e3+"s "+o.delayBeforeStart/1e3+"s "+o.css3easing}animationCss={transform:"translateX("+(o.direction==="left"?"-"+elWidth+"px":containerWidth+"px")+")"};loopCount++}else if(loopCount===3){o.duration=o._completeDuration;if(animationCss3Str){animationName=animationName+"0";keyframeString=$.trim(keyframeString)+"0 ";animationCss3Str=animationName+" "+o.duration/1e3+"s 0s infinite "+o.css3easing}_rePositionHorizontally()}}else{_rePositionHorizontally();animationCss={transform:"translateX("+(o.direction==="left"?"-"+elWidth+"px":containerWidth+"px")+")"}}}$this.trigger("beforeStarting");if(css3AnimationIsSupported){$marqueeWrapper.css(animationString,animationCss3Str);var keyframeCss=keyframeString+" { 100%  "+_objToString(animationCss)+"}",$styles=$marqueeWrapper.find("style");if($styles.length!==0){$styles.filter(":last").html(keyframeCss)}else{$("head").append("<style>"+keyframeCss+"</style>")}_prefixedEvent($marqueeWrapper[0],"AnimationIteration",function(){$this.trigger("finished")});_prefixedEvent($marqueeWrapper[0],"AnimationEnd",function(){animate();$this.trigger("finished")})}else{$marqueeWrapper.animate(animationCss,o.duration,o.easing,function(){$this.trigger("finished");if(o.pauseOnCycle){_startAnimationWithDelay()}else{animate()}})}$this.data("runningStatus","resumed")};$this.on("pause",methods.pause);$this.on("resume",methods.resume);if(o.pauseOnHover){$this.on("mouseenter",methods.pause);$this.on("mouseleave",methods.resume)}if(css3AnimationIsSupported&&o.allowCss3Support){animate()}else{_startAnimationWithDelay()}})};$.fn.marquee.defaults={allowCss3Support:true,css3easing:"linear",easing:"linear",delayBeforeStart:1e3,direction:"left",duplicated:false,duration:5e3,speed:0,gap:20,pauseOnCycle:false,pauseOnHover:false,startVisible:false}});
$('.homepage-marquee').marquee({
  duration: 70000,
  gap: 0,
  delayBeforeStart: 0,
  direction: 'left',
  duplicated: true,
  startVisible: true
});

var width = $(window).width();
if(width > 768)
{
  $('.homepage-marquee-1').marquee({
    duration: 130000,
    gap: 0,
    delayBeforeStart: 0,
    direction: 'left',
    duplicated: true,
    pauseOnHover:true,
    startVisible: true
  });
  
  $('.homepage-marquee-1-reverse').marquee({
    duration: 130000,
    gap: 0,
    delayBeforeStart: 0,
    direction: 'right',
    duplicated: true,
    pauseOnHover:true,
    startVisible: true
  });
}

/* BMI custom */

function bmiAddToCart() {
  document.addEventListener("bmi_add_to_cart", e => {
    const { size } = e.detail; // This is the size the user selected
    
    // First: find the buttons corresponding to available sizes on my PDP
    const sizeOptionWrapper = document.querySelector('.product-variant-select__input-group--size');
    const sizeInputs = sizeOptionWrapper.querySelectorAll('input');
    
    // Second: find the button corresponding with the size 
    // the user selected as well as the add to cart button
    const selectedItem = Array.from(sizeInputs).find((item) => item.value == size);
    const addToCartLink = document.querySelector('.Product_main_template_inner_new .button_add_to_cart_new');
    
    // Third: Pick the size the user selected in the SSC Flow
    if (selectedItem) {
      selectedItem.click();
    }
    // Last: add the selected size to cart
    // if (addToCartLink) {
    //   addToCartLink.click()
    // }
    
  });
}

bmiAddToCart();

/* custom */

const PDP_SECTION_INNER_SELECTORS = {
  '.Product_meta_object_products_list_new': '.Product_meta_object_products_list_main_new',
  '.Product_review_new': '.Product_review_main_new',
  '.Product_meta_object_all_weather_new': '.Product_meta_object_all_weather_main_new',
};

const PDP_SECTION_SCHEMA_CLASSES = {
  main: 'Product_main_template_new',
  productsList: 'Product_meta_object_products_list_new',
  review: 'Product_review_new',
  weather: 'Product_meta_object_all_weather_new',
};

function getMarketPathFromUrl() {
  const match = window.location.pathname.match(/^(\/[a-z]{2}-[a-z]{2})(?=\/products\/)/i);
  return match ? match[1] : '';
}

function buildProductPageUrl(productHandle) {
  return `${location.origin}${getMarketPathFromUrl()}/products/${productHandle}`;
}

function buildSectionFetchUrl(productPath, sectionId) {
  const normalized = String(productPath).replace(/^\/products\//, '');
  const separator = normalized.includes('?') ? '&' : '?';
  return `${location.origin}/products/${normalized}${separator}section_id=${encodeURIComponent(sectionId)}`;
}

function getMainProductSectionId() {
  return document.querySelector('.Product_main_template_main_new')?.getAttribute('data-section-id') || '';
}

function getSectionIdBySchemaClass(schemaClass) {
  const sectionEl = document.querySelector(`.shopify-section.${schemaClass}`);
  if (!sectionEl?.id) return '';
  return sectionEl.id.replace(/^shopify-section-/, '');
}

function parseSectionHtml(html) {
  return new DOMParser().parseFromString(html, 'text/html');
}

function findSectionContent(doc, sectionClass) {
  const innerSelector = PDP_SECTION_INNER_SELECTORS[sectionClass];
  return (
    doc.querySelector(sectionClass) ||
    (innerSelector ? doc.querySelector(innerSelector) : null) ||
    doc.body?.firstElementChild
  );
}

function isValidMainProductSection(node) {
  if (!node) return false;

  const container = node.matches?.('.Product_main_template_main_new')
    ? node
    : node.querySelector?.('.Product_main_template_main_new');

  if (!container) return false;

  const hasMedia = container.querySelector(
    '.Product_main_images_new img, .product_image_slider_new .swiper-slide img, .product_image_slider_new .swiper-slide'
  );
  const hasPurchaseUI = container.querySelector(
    '.colors-group-wrapper, .product-variant-select, .fake-select, .button_add_to_cart_new'
  );

  return !!(hasMedia && hasPurchaseUI);
}

function resolveSectionInnerNode(importedNode, sectionClass) {
  const className = sectionClass.replace('.', '');
  if (importedNode.matches?.(sectionClass) || importedNode.classList?.contains(className)) {
    return importedNode;
  }

  const innerSelector = PDP_SECTION_INNER_SELECTORS[sectionClass];
  return (
    importedNode.querySelector(sectionClass) ||
    (innerSelector ? importedNode.querySelector(innerSelector) : null) ||
    importedNode
  );
}

function replaceSectionContent(sectionId, sectionClass, newNode) {
  const sectionEl = document.getElementById(`shopify-section-${sectionId}`);
  if (!sectionEl || !newNode) return false;

  const importedNode = document.importNode(newNode, true);
  const innerSelector = PDP_SECTION_INNER_SELECTORS[sectionClass];
  const currentInner =
    sectionEl.querySelector(sectionClass) || (innerSelector ? sectionEl.querySelector(innerSelector) : null);
  const newInner = resolveSectionInnerNode(importedNode, sectionClass);

  if (currentInner) {
    currentInner.replaceWith(document.importNode(newInner, true));
    return true;
  }

  if (importedNode.id === `shopify-section-${sectionId}`) {
    sectionEl.replaceWith(importedNode);
    return true;
  }

  sectionEl.innerHTML = importedNode.outerHTML;
  return true;
}

function getSelectedVariantUpc(root) {
  const scope = root || document;
  const checked = scope.querySelector('.product-variant-select input[type="radio"]:checked');

  if (checked?.dataset?.barcode) {
    return checked.dataset.barcode;
  }

  const firstWithBarcode = scope.querySelector(
    '.product-variant-select input[type="radio"][data-barcode]:not([data-barcode=""])'
  );

  return firstWithBarcode?.dataset?.barcode || '';
}

function buildLocallyConfig(upc) {
  return {
    company_name: 'Halfdays',
    button_text: ':marker: Find In Store',
    button_id: 'HTML',
    company_id: '300767',
    css: '7',
    n_buy_online_results: '3',
    upc: upc || '',
    lang: 'en-us',
    n_dealers: '3',
    no_link: '1',
    link_opens_modal: '1',
  };
}

function buildLocallyScriptUrl(config) {
  const query = Object.keys(config)
    .reduce(function (parts, key) {
      const value = config[key];
      parts.push(
        encodeURIComponent(key) +
          '=' +
          encodeURIComponent(
            typeof value === 'object' && value !== null ? JSON.stringify(value) : value
          )
      );
      return parts;
    }, [])
    .join('&');

  return `https://halfdays.locally.com/stores/map.js?${query}`;
}

function initLocallyWidget(root) {
  const scope = root || document.querySelector('.Product_main_template_main_new');
  const buttonWrap = scope?.querySelector('#lcly-button-0');

  if (!buttonWrap) {
    return;
  }

  const upc = getSelectedVariantUpc(scope);

  document.querySelectorAll('#lcly-script-0').forEach((scriptEl) => scriptEl.remove());

  Array.from(buttonWrap.children).forEach((child) => {
    if (child.id !== 'lcly-link-0') {
      child.remove();
    }
  });

  let link = buttonWrap.querySelector('#lcly-link-0');
  if (!link) {
    link = document.createElement('a');
    link.id = 'lcly-link-0';
    link.setAttribute('data-switchlive', 'true');
    link.setAttribute('data-switchlive-mode', 'auto');
    link.setAttribute('data-switchlive-id-PL', '6');
    link.setAttribute('role', 'button');
    link.href = 'https://join.locally.com/for-brands';
    link.target = '_blank';
    buttonWrap.appendChild(link);
  }

  link.textContent = 'Product Locator by Locally';
  link.removeAttribute('style');

  window.__lcly_channel_domain_0 = 'locally';

  const script = document.createElement('script');
  script.id = 'lcly-script-0';
  script.async = true;
  script.src = buildLocallyScriptUrl(buildLocallyConfig(upc));
  buttonWrap.insertAdjacentElement('afterend', script);
}

function bindLocallyVariantReload() {
  if (window.__locallyVariantReloadBound) {
    return;
  }
  window.__locallyVariantReloadBound = true;

  document.addEventListener('change', function (e) {
    const input = e.target;
    if (!input?.matches?.('.Product_main_template_main_new .product-variant-select input[type="radio"]')) {
      return;
    }
    if (!input.checked) {
      return;
    }

    const upc = input.dataset.barcode;
    if (!upc) {
      return;
    }

    if (typeof window.lcly_reload_0 === 'function') {
      window.lcly_reload_0({ upc });
    } else {
      initLocallyWidget(input.closest('.Product_main_template_main_new'));
    }
  });
}

function initMainProductSectionAfterSwap() {
  if (typeof theme === 'undefined') return;

  var sections = new theme.Sections();
  sections.register('product-new', theme.ProductNew);

  // The inline script that normally clears data-bound/aria-busy on the ATC button
  // does not re-execute after a DOMParser-based section swap. Clear them here so
  // the button doesn't stay greyed out / stuck in "loading" state after a color switch.
  document.querySelectorAll('.button_add_to_cart_new-js').forEach(function(btn) {
    btn.setAttribute('data-bound', '1');
    btn.removeAttribute('aria-busy');
  });

  scrollLink();
  accordionScript();
  if (typeof window.initProductAccordions === 'function') {
    const section = document.querySelector('.Product_main_template_main_new');
    if (section) window.initProductAccordions(section);
  }
  upsellMainSlider();
  mainImageProductAccordion();
  mainProductMobileSlider();
  window.updateUnavailableOptions?.();

  document.dispatchEvent(
    new CustomEvent('bmi_reload', {
      bubbles: true,
    })
  );

  bmiAddToCart();
  bindLocallyVariantReload();

  var manPDPcontainer = document.querySelector('.Product_main_template_main_new');
  if (manPDPcontainer) {
    var sectionId = manPDPcontainer.getAttribute('data-section-id');
    new theme.Photoswipe(manPDPcontainer, sectionId);

    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        initLocallyWidget(manPDPcontainer);
      });
    });
  }

  if (typeof bindBISModalEvents === 'function') {
    bindBISModalEvents();
  }

  var checkedSize = document.querySelector('.product-variant-select__input-group--size input[type="radio"]:checked');
  if (checkedSize && typeof updateColorSwatchesForSize === 'function') {
    updateColorSwatchesForSize(checkedSize.value);
  }

  document.querySelector('.product-variant-select__size-chart')?.addEventListener('click', function () {
    document.querySelector('#size-chat-drawer')?.classList.add('hideDrawer');
  });

  document.querySelector('#currentSize_new')?.addEventListener('click', function () {
    document.querySelector('#size-chat-drawer')?.classList.add('hideDrawer');
  });
}

const pdpSectionHtmlCache = new Map();

async function fetchSectionHtml(url) {
  if (pdpSectionHtmlCache.has(url)) {
    return pdpSectionHtmlCache.get(url);
  }
  let response;
  try {
    response = await fetch(url);
  } catch (err) {
    console.warn('fetchProductData failed:', url, err);
    return null;
  }
  if (!response.ok) {
    console.warn('fetchProductData non-OK response:', url, response.status);
    return null;
  }
  const html = await response.text();
  if (!html || !html.trim()) return null;
  pdpSectionHtmlCache.set(url, html);
  return html;
}

async function prefetchProductSections(productHandle) {
  if (!productHandle) return;
  const config = getPdpSectionConfig();
  const urls = [];
  if (config.mainProductSectionId) urls.push(buildSectionFetchUrl(productHandle, config.mainProductSectionId));
  if (config.metaObjectProductListSectionId) urls.push(buildSectionFetchUrl(productHandle, config.metaObjectProductListSectionId));
  if (config.weatherSectionId) urls.push(buildSectionFetchUrl(productHandle, config.weatherSectionId));
  if (config.reviewSectionId) urls.push(buildSectionFetchUrl(productHandle, config.reviewSectionId));
  await Promise.all(urls.map(url => fetchSectionHtml(url)));
}

async function fetchProductData(url, sectionClass, sectionId) {
  if (!url || !sectionClass || !sectionId || /section_id=(?:&|$)/.test(url)) {
    return false;
  }

  const html = await fetchSectionHtml(url);
  if (!html) {
    return false;
  }

  const htmlDoc = parseSectionHtml(html);
  const newContent = findSectionContent(htmlDoc, sectionClass);

  if (!newContent) {
    return false;
  }

  if (sectionClass === '.Product_main_template_main_new' && !isValidMainProductSection(newContent)) {
    return false;
  }

  if (!replaceSectionContent(sectionId, sectionClass, newContent)) {
    return false;
  }

  if (sectionClass === '.Product_main_template_main_new') {
    initMainProductSectionAfterSwap();
  } else if (sectionClass === '.Product_meta_object_products_list_new') {
    productListSectionSlider();
  } else if (sectionClass === '.Product_review_new') {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = 'https://d3hw6dc1ow8pp2.cloudfront.net/reviewsWidget.min.js?shop=halfdays.myshopify.com';
    document.body.appendChild(script);
  } else if (sectionClass === '.Product_meta_object_all_weather_new') {
    weatherSectionScript();
  }

  return true;
}

const PDP_COLOR_SWATCH_SELECTOR = '.colors-group-wrapper [js-product-color][role="radio"]';

function getCurrentProductHandle() {
  const pv = document.querySelector('.product-variant-select__input[data-product]');
  return pv?.dataset?.product || '';
}

function getPdpSectionConfig() {
  const mainProductSection = '.Product_main_template_main_new';
  const metaObjectProductListSection = '.Product_meta_object_products_list_new';
  const weatherMetaObjectSection = '.Product_meta_object_all_weather_new';
  const reviewSection = '.Product_review_new';

  return {
    mainProductSection,
    metaObjectProductListSection,
    weatherMetaObjectSection,
    reviewSection,
    mainProductSectionId: getMainProductSectionId(),
    metaObjectProductListSectionId: getSectionIdBySchemaClass(PDP_SECTION_SCHEMA_CLASSES.productsList),
    reviewSectionId: getSectionIdBySchemaClass(PDP_SECTION_SCHEMA_CLASSES.review),
    weatherSectionId: getSectionIdBySchemaClass(PDP_SECTION_SCHEMA_CLASSES.weather),
  };
}

function isDisabledColorRadio(el) {
  return el.getAttribute('aria-disabled') === 'true' || el.classList.contains('disabled');
}

function getPdpColorRadioGroup(el) {
  return el.closest('.colors-group-wrapper [role="radiogroup"]');
}

function getEnabledPdpColorRadios(group) {
  return Array.from(group.querySelectorAll(PDP_COLOR_SWATCH_SELECTOR))
    .filter((r) => !isDisabledColorRadio(r));
}

function setActivePdpColorRadio(group, activeRadio) {
  const radios = Array.from(group.querySelectorAll(PDP_COLOR_SWATCH_SELECTOR));

  radios.forEach((r) => {
    const isActive = r === activeRadio;
    r.setAttribute('aria-checked', isActive ? 'true' : 'false');
    r.setAttribute('tabindex', isActive ? '0' : '-1');
    r.classList.toggle('selected', isActive);
    r.style.removeProperty('outline');
  });
}

let pdpColorSwitchInFlight = false;

async function switchPdpProductByHandle(productHandle) {
  if (!productHandle || pdpColorSwitchInFlight) return;

  const currentProductHandle = getCurrentProductHandle();
  if (productHandle === currentProductHandle) {
    return;
  }

  const config = getPdpSectionConfig();
  const productPageUrl = buildProductPageUrl(productHandle);

  if (!config.mainProductSectionId) {
    window.location.href = productPageUrl;
    return;
  }

  pdpColorSwitchInFlight = true;
  document.body.classList.add('pdp-color-switching');

  const mainProductSectionUrl = buildSectionFetchUrl(productHandle, config.mainProductSectionId);
  const mainUpdated = await fetchProductData(
    mainProductSectionUrl,
    config.mainProductSection,
    config.mainProductSectionId
  );

  if (!mainUpdated) {
    document.body.classList.remove('pdp-color-switching');
    pdpColorSwitchInFlight = false;
    window.location.href = productPageUrl;
    return;
  }

  window.history.pushState({}, '', productPageUrl);

  const secondaryUpdates = [];

  if (config.metaObjectProductListSectionId) {
    secondaryUpdates.push(
      fetchProductData(
        buildSectionFetchUrl(productHandle, config.metaObjectProductListSectionId),
        config.metaObjectProductListSection,
        config.metaObjectProductListSectionId
      )
    );
  }
  if (config.weatherSectionId) {
    secondaryUpdates.push(
      fetchProductData(
        buildSectionFetchUrl(productHandle, config.weatherSectionId),
        config.weatherMetaObjectSection,
        config.weatherSectionId
      )
    );
  }
  if (config.reviewSectionId) {
    secondaryUpdates.push(
      fetchProductData(
        buildSectionFetchUrl(productHandle, config.reviewSectionId),
        config.reviewSection,
        config.reviewSectionId
      )
    );
  }

  await Promise.all(secondaryUpdates);

  document.body.classList.remove('pdp-color-switching');
  pdpColorSwitchInFlight = false;
}

function initPdpColorSwatches() {
  if (!document.querySelector('.product-variant-select__input')) {
    return;
  }

  if (!window.__pdpColorSwatchA11yBound) {
    window.__pdpColorSwatchA11yBound = true;

    document.addEventListener('keydown', function (e) {
      const radio = e.target.closest(PDP_COLOR_SWATCH_SELECTOR);
      if (!radio) return;

      const group = getPdpColorRadioGroup(radio);
      if (!group) return;

      if (e.key === ' ' || e.key === 'Enter') {
        e.preventDefault();
        if (!isDisabledColorRadio(radio)) {
          setActivePdpColorRadio(group, radio);
          radio.click();
        }
        return;
      }

      const isPrev = (e.key === 'ArrowLeft' || e.key === 'ArrowUp');
      const isNext = (e.key === 'ArrowRight' || e.key === 'ArrowDown');
      if (!isPrev && !isNext) return;

      e.preventDefault();

      const enabled = getEnabledPdpColorRadios(group);
      const idx = enabled.indexOf(radio);
      if (idx === -1) return;

      const nextIdx = isPrev
        ? (idx - 1 + enabled.length) % enabled.length
        : (idx + 1) % enabled.length;

      enabled[nextIdx].focus();
    }, true);

    document.addEventListener('click', function (e) {
      const radio = e.target.closest(PDP_COLOR_SWATCH_SELECTOR);
      if (!radio) return;

      const group = getPdpColorRadioGroup(radio);
      if (!group || isDisabledColorRadio(radio)) return;

      setActivePdpColorRadio(group, radio);
    }, true);
  }

  if (window.__pdpColorSwitchBound) {
    return;
  }
  window.__pdpColorSwitchBound = true;

  $(document).on('click.pdpColorSwitch', PDP_COLOR_SWATCH_SELECTOR, function (e) {
    e.preventDefault();

    const productHandle = $(this).data('productHandle');
    switchPdpProductByHandle(productHandle);
  });

  $(document).on('click.pdpColorSwitch', '.colors-group-wrapper .color-wrapper', function (e) {
    const swatch = this.querySelector('[js-product-color][role="radio"]');
    if (!swatch || swatch.contains(e.target)) {
      return;
    }
    swatch.click();
  });

  $(document).on('click.pdpSizingSwitch', '.Product_image_sizing_list_main_new .Product_image_sizing_list_new', async function () {
    const variantUrl = $(this).data('variantUrl');
    const config = getPdpSectionConfig();

    if (!variantUrl || !config.mainProductSectionId) {
      return;
    }

    const productPageUrl = `${location.origin}${getMarketPathFromUrl()}/products/${variantUrl}`;
    const mainUpdated = await fetchProductData(
      buildSectionFetchUrl(variantUrl, config.mainProductSectionId),
      config.mainProductSection,
      config.mainProductSectionId
    );

    if (!mainUpdated) {
      window.location.href = productPageUrl;
      return;
    }

    window.history.pushState({}, '', productPageUrl);

    if (config.metaObjectProductListSectionId) {
      fetchProductData(
        buildSectionFetchUrl(variantUrl, config.metaObjectProductListSectionId),
        config.metaObjectProductListSection,
        config.metaObjectProductListSectionId
      );
    }
  });

  $(document).on('mouseenter.pdpLengthPrefetch', '.product-variant-select__input.sizeable-product[js-product-color]', function () {
    const productHandle = $(this).data('productHandle');
    prefetchProductSections(productHandle);
  });

  $(document).on('click.pdpLengthSwitch', '.product-variant-select__input.sizeable-product[js-product-color]', function (e) {
    e.preventDefault();
    const productHandle = $(this).data('productHandle');
    switchPdpProductByHandle(productHandle);
  });
}

function selectProductColor() {
  initPdpColorSwatches();
}


function updateColorSwatchesForSize(selectedSize) {
  if (!selectedSize) return;
  document.querySelectorAll('.colors-group-wrapper [js-product-color]').forEach(function(swatch) {
    var sizes = (swatch.dataset.availableSizes || '').split(',').map(function(s) { return s.trim(); });
    var available = sizes.length > 0 && sizes[0] !== '' && sizes.indexOf(selectedSize) !== -1;
    swatch.classList.toggle('size-oos', !available);
  });
}

function initSizeBasedColorAvailability() {
  document.addEventListener('change', function(e) {
    var input = e.target;
    if (!input || !input.matches('.product-variant-select__input-group--size input[type="radio"]')) return;
    if (!input.checked) return;
    updateColorSwatchesForSize(input.value);
  });

  var checkedSize = document.querySelector('.product-variant-select__input-group--size input[type="radio"]:checked');
  if (checkedSize) {
    updateColorSwatchesForSize(checkedSize.value);
  }
}

if (document.querySelector('.product-variant-select__input')) {
  try {
    selectProductColor();
    bindLocallyVariantReload();
    initSizeBasedColorAvailability();
  } catch (e) {
    console.warn('selectProductColor() skipped:', e);
  }
}

// Ensure size radio accessibility is initialized on page load
document.addEventListener('DOMContentLoaded', function() {
  initSizeRadioA11y();
});


function initSizeRadioA11y(root = document) {
  const sizeGroups = root.querySelectorAll('.product-variant-select__input-group--size');

  sizeGroups.forEach((group) => {
    const radios = Array.from(group.querySelectorAll('input[type="radio"]'));
    if (!radios.length) return;

    // Remove any aria-checked attributes if present (should not be on native radios)
    radios.forEach(r => r.removeAttribute('aria-checked'));
  });
}

/* Collection Load More End */

function initDropdown() {
  // Accessible ARIA listbox pattern for Sort By dropdown
  var $dropdown = $(".sortby-dropdown[role='listbox']");
  var $options = $dropdown.find('.sortby-option[role="option"]');

  // Click to select
  $options.on('click', function() {
    var idx = $options.index(this);
    updateSortbySelection(idx);
    $options.eq(idx).focus();
  });

  // Keyboard navigation
  $dropdown.on('keydown', function(e) {
    var $focused = $(document.activeElement);
    var idx = $options.index($focused);
    if (e.key === 'ArrowDown') {
      var next = (idx + 1) % $options.length;
      $options.eq(next).focus();
      updateSortbySelection(next);
      e.preventDefault();
    } else if (e.key === 'ArrowUp') {
      var prev = (idx - 1 + $options.length) % $options.length;
      $options.eq(prev).focus();
      updateSortbySelection(prev);
      e.preventDefault();
    } else if (e.key === 'Enter' || e.key === ' ') {
      if (idx >= 0) {
        updateSortbySelection(idx);
        // Optionally trigger sort action here
      }
      e.preventDefault();
    }
  });

  function updateSortbySelection(selectedIdx) {
    $options.each(function(i) {
      $(this).attr('aria-selected', i === selectedIdx ? 'true' : 'false');
      this.tabIndex = i === selectedIdx ? 0 : -1;
    });
  }
};
initDropdown();
document.addEventListener("dropdown:init", initDropdown);

$(document).mouseup(function(e) 
{
    var container = $(".Blog_alternate_template_2_leftside_sortby_new .filter-item");

    // if the target of the click isn't the container nor a descendant of the container
    if (!container.is(e.target) && container.has(e.target).length === 0) 
    {
        $(".Blog_alternate_template_2_leftside_sortby_new .filter-item").removeClass("selected");
    }
});

function initFilterDrawer () {
  $(".filter_mobile_new").click(function() {
    $(this).next(".Blog_alternate_template_2_leftside_filter_new").addClass("open");
  })
  $(".filter_mobile_heading_close_new, .filter_mobile_dropdown_footer_view_new .btn").click(function() {
    $(".Blog_alternate_template_2_leftside_filter_new").removeClass("open");
  })
  $(".filter_mobile_dropdown_title_new").click(function() {
    $(this).toggleClass("open");
    $(this).next(".Blog_alternate_template_2_leftside_filter_value_new").slideToggle();
  })
};
initFilterDrawer();
document.addEventListener("filter-drawer:init", initFilterDrawer);

function sectionwidth()
{
  var width = $(document).width();
  var Article_alternate_temp_inner_new = $(".Article_alternate_temp_inner_new").width();
  var totalwidth = width - Article_alternate_temp_inner_new;
  totalwidth = totalwidth/2;
  var Article_alternate_temp_innerright_1_new = $(".Article_alternate_temp_innerright_1_new").width();
  var finalwidth = totalwidth + Article_alternate_temp_innerright_1_new;
  $(".Article_alternate_temp_innerright_1_product_detailloop_new").css("width",finalwidth+"px");
}
sectionwidth()
$(window).resize(function(){
  sectionwidth()
});

$('a[href^="#"]').on('click', function(event) {
  var target = $($(this).attr('href'));
  if (target.length) {
    event.preventDefault();
    $('html, body').stop().animate({
        scrollTop: target.offset().top
    }, 500);
  }
});

new Swiper('.Page_about_video_image_columns_slider', {
  loop: false,
  grabCursor: false,
  spaceBetween: 0,
  slidesPerView: 2,
  watchSlidesProgress: true,
  draggable:!0,
  autoHeight:!1,
  watchOverflow:!0,
  threshold:10,
  mousewheel:{
    forceToAxis:!0
  },
  breakpoints: {
    0: {
      slidesPerView: "auto",
    },
    769: {
      slidesPerView: 2,
    },
    992: {
      slidesPerView: 2,
    },
    1200: {
      slidesPerView: 2,
    },
    1360: {
      slidesPerView: 2,
    },
    1441: {
      slidesPerView: 2,
      freeMode:!0
    }
  }
});

/* Faq */
$(".Page_faqs_accordions_leftside_listheading_new a").click(function () {
  $(".Page_faqs_accordions_leftside_listheading_new a").removeClass("active");
  $(this).addClass("active");
  var Link_text = $(this).attr("data-link");

  $(".Page_faqs_accordions_rightside_new").css("display","none");
  $("#"+Link_text).css("display","block");
});
/* Faq */

$(document).ready(function(){   
  var hash = $(location).attr('hash'); 
  var datalink = $(hash+"_1").attr("data-link");
  var ID = $(hash+"_1").attr("id");
  if($("#"+ID).length > 0)
  {
    $(".Page_faqs_accordions_leftside_listheading_new a").removeClass("active");
    $("#"+ID).addClass("active");
    
    $(".Page_faqs_accordions_rightside_new").css("display","none");
    $("#"+datalink).css("display","block");
  }
});


/* Page_comparison_table_slider */
new Swiper('.Page_comparison_table_slider', {
  loop: false,
  grabCursor: false,
  spaceBetween: 0,
  slidesPerView: "auto",
  watchSlidesProgress: true,
  draggable:!0,
  autoHeight:!1,
  watchOverflow:!0,
  threshold:10,
  mousewheel:{
    forceToAxis:!0
  },
  freeMode:!0,
  scrollbar: {
    el: ".swiper-scrollbar"
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  observer: true,
  observeParents: true,
});

function initTabsCollectionNew() {
  $(".tabs_collection_new").click(function(){
    var tab_id = $(this).attr("tab_id");
    $(this).parents(".tabs_collection_main_new").find(".tabs_collection_new").removeClass("active");
    $(this).parents(".tabs_collection_main_new").find(".tabcontent").css("display","none");
  
    $(this).addClass("active");
    $(this).parents(".tabs_collection_main_new").find("."+tab_id+"_open").css("display","block");
  })
};
initTabsCollectionNew();

$(".Page_comparison_template_innerright_desktop_allloop_mainbox_new").click(function() {
  var tab_height = $(".Page_comparison_template_main_new").outerHeight(true);
  var tab_desktop_id = $(this).attr("tab_desktop_id");
  $('html,body').animate({
    scrollTop: $("#"+tab_desktop_id).offset().top - tab_height
  },1000);
});

/*-- FIX_HEADER_START --*/
$(function(){
  setTimeout(function() {
    var $el = $('.Page_comparison_template_main_new');  //record the elem so you don't crawl the DOM everytime  
    var $el2 = $('.Page_comparison_instagram_main_new'); 
    
    if($el.length > 0){
      var stickyHeaderTop = $el.position().top;  // passing "true" will also include the top and bottom margin
    }
    if($el2.length > 0){
      var stickyHeaderTop2 = $el2.position().top;  // passing "true" will also include the top and bottom margin
    }
    $(window).scroll(function(){
      if( $(window).scrollTop() > stickyHeaderTop2 ) {
        $('body').removeClass('fix_price_top');
      }
      else if( $(window).scrollTop() > stickyHeaderTop ) {
        if($('body').hasClass("fix_price_top") == false)
        {
          $('body').addClass('fix_price_top');
        }
      }
      else {
        $('body').removeClass('fix_price_top');
      }
    });
  },2000);
});
/*-- FIX_HEADER_END --*/

$(".Page_comparison_meta_table_innermobile_1_detail_innerselect_title_new").click(function() {
  $(".Page_comparison_meta_table_innermobile_1_detail_innerselect_infos_new").css("display","none");
  if($(this).hasClass("active") == false)
  {
    $(this).addClass("active");
    $(this).next(".Page_comparison_meta_table_innermobile_1_detail_innerselect_infos_new").css("display","block");
  }
  else
  {
    $(this).removeClass("active");
    $(this).next(".Page_comparison_meta_table_innermobile_1_detail_innerselect_infos_new").css("display","none");
  }
})

$(document).mouseup(function(e) 
{
    var container = $(".Page_comparison_meta_table_innermobile_1_detail_innerselect_title_new");

    // if the target of the click isn't the container nor a descendant of the container
    if (!container.is(e.target) && container.has(e.target).length === 0) 
    {
        $(".Page_comparison_meta_table_innermobile_1_detail_innerselect_title_new").removeClass("active");
        $(".Page_comparison_meta_table_innermobile_1_detail_innerselect_infos_new").css("display","none");
    }
});

$(".Page_comparison_template_innerright_mobile_allloop_mainbox_new").click(function(){
  var tab_mobile_id = $(this).attr("tab_mobile_id");
  $(".Page_comparison_template_innerright_mobile_allloop_mainbox_new").removeClass("active");
  $(".Page_comparison_meta_table_main_new").removeClass("active");

  $(this).addClass("active");
  $("#"+tab_mobile_id).addClass("active");
})

$(".tabs_collection_new_m").click(function(){
  var tab_id_m = $(this).attr("tab_id_m");
  $(this).parents(".tabs_collection_main_new_m").find(".tabs_collection_new_m").removeClass("active");
  $(this).parents(".tabs_collection_main_new_m").find(".tabcontent_m").css("display","none");

  $(this).addClass("active");
  $(this).parents(".tabs_collection_main_new_m").find("."+tab_id_m+"_open").css("display","block");

  var drop_title =  $(this).find('p').html();
  $(this).parents(".Page_comparison_meta_table_innermobile_1_detail_innerselect_new").find(".Page_comparison_meta_table_innermobile_1_detail_innerselect_title_new span").html(drop_title);
})

$(".Page_comparison_meta_table_innermobile_1_detail_innerselect_infos_texts_new").click(function() {
  var drop_title =  $(this).find('h4').html();
  $(this).parents(".Page_comparison_meta_table_innermobile_1_detail_innerselect_new").find(".Page_comparison_meta_table_innermobile_1_detail_innerselect_title_new span").html(drop_title);
})



//========= Currency converter 

if($('#localization_form').length > 0) {
  if($('#localization_form [data-disclosure-list]').attr('data-template') == 'index') {
         let returnURL = $('#localization_form input[name="return_to"]').val();
         if(returnURL.indexOf('?viewcart=true') != -1) {
           let newCurrencyUrl = returnURL.replace('?viewcart=true', '');
           $('#localization_form input[name="return_to"]').val(newCurrencyUrl);
         }
  }
}

//Cookie Banner Scroll Fix
document.addEventListener("DOMContentLoaded", function () {
  initSizeRadioA11y();
});


(function () {
  function initSizeRadioA11y(root = document) {
    const groups = root.querySelectorAll('.product-variant-select__input-group--size[role="radiogroup"]');

    groups.forEach((group) => {
      const radios = Array.from(group.querySelectorAll('input[type="radio"]'));
      if (!radios.length) return;

      const setTabIndexes = () => {
        let checked = radios.find(r => r.checked && !r.disabled);
        if (!checked) checked = radios.find(r => !r.disabled);
        radios.forEach(r => r.tabIndex = -1);
        if (checked) checked.tabIndex = 0;
      };

      // initial
      setTabIndexes();

      // change update
      radios.forEach((radio) => {
        radio.addEventListener('change', setTabIndexes);
      });

      // Arrow nav
      // No custom keydown handler: let browser handle arrow keys for native radios
    });
  }

  // run on load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initSizeRadioA11y());
  } else {
    initSizeRadioA11y();
  }

  // If your PDP updates options after selecting variants, call again after that update.
  // Example: if you have window.updateUnavailableOptions(), call initSizeRadioA11y() at the end of it.
  window.initSizeRadioA11y = initSizeRadioA11y;
})();
